export default __webpack_public_path__ + "static/media/NunitoSans-Regular.cb66302a.ttf";